import { render, staticRenderFns } from "./InstagramCallback.vue?vue&type=template&id=34c75718&"
import script from "./InstagramCallback.vue?vue&type=script&lang=js&"
export * from "./InstagramCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports